var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_84",
    width: 16.999,
    height: 12.907,
    viewBox: "0 0 16.999 12.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4715",
    d: "M-165.094-311.907v1.514l-.126.186c-.124.184-.246.375-.364.571h1.5a12.273 12.273 0 0 0-2.772 7.053h2.706a13.431 13.431 0 0 1 2.161-7.149v-2.176z",
    fill: "currentColor",
    transform: "translate(178.984 313.628)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4716",
    d: "M-461.539-222.258h2.706a13.19 13.19 0 0 1 1.714-6.336h-2.187a11.943 11.943 0 0 0-2.233 6.336z",
    fill: "currentColor",
    transform: "translate(463.49 233.303)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4717",
    d: "M-518-311.907v2.885h1.691v-.615h1.419v-2.271z",
    fill: "currentColor",
    transform: "translate(518 313.628)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4718",
    d: "M-404.335-359.907H-408v3.992h3.017v-.851h3.493c-1.737 2.127-3.821 6.047-3.821 9.766h3.73a18.655 18.655 0 0 1 2.978-9.9v-3.009h-5.733z",
    fill: "currentColor",
    transform: "translate(411.801 359.907)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.74e8b70e.svg";
export { ForwardRef as ReactComponent };